import { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';
import Navbar from '../../components/Navbar/Navbar';
import CatalogPicker from './CatalogPicker';
import CatalogCRUD from './CatalogCRUD';
import { CATALOGS } from './catalogConfig';
import './Catalogs.css';

function Catalogs() {
  const [selectedKey, setSelectedKey] = useState(null);
  const [role, setRole] = useState(null);

  useEffect(() => {
    async function fetchRole() {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return;
      const { data } = await supabase
        .from('users')
        .select('roles(name)')
        .eq('id', user.id)
        .single();
      setRole(data?.roles?.name ?? null);
    }
    fetchRole();
  }, []);

  const config = CATALOGS.find((c) => c.key === selectedKey);
  const canEdit = role === 'Gerente';

  return (
    <div className="cat-page">
      <Navbar />
      <main className="cat-main">
        {config ? (
          <CatalogCRUD
            config={config}
            canEdit={canEdit}
            onBack={() => setSelectedKey(null)}
          />
        ) : (
          <CatalogPicker onSelect={setSelectedKey} />
        )}
      </main>
    </div>
  );
}

export default Catalogs;
